export const technical = {
  systems: {
    title: "Technical Systems",
    hvac: "HVAC",
    electrical: "Electrical",
    plumbing: "Plumbing",
    fire: "Fire Protection",
    security: "Security",
    automation: "Building Automation",
    elevator: "Elevator",
    communication: "Communication",
  },
  status: {
    operational: "Operational",
    maintenance: "Maintenance",
    repair: "Repair",
    replacement: "Replacement",
  },
  data: {
    title: "Technical Data",
    noDataAvailable: "No technical data available",
    createRecord: "Create technical data record",
    grossArea: "Gross Area",
    leasableArea: "Leasable Area",
    buildingHeight: "Building Height",
    plotSize: "Plot Size",
    builtUpPercentage: "Built Up Percentage",
    floorLoadCapacity: "Floor Load Capacity",
    buildingFootprint: "Building Footprint",
    siteCoverageRatio: "Site Coverage Ratio",
    floorAreaRatio: "Floor Area Ratio",
    placeholder: "Not specified",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    saving: "Saving...",
    successTitle: "Success",
    successDesc: "Technical data updated successfully",
    errorTitle: "Error",
    errorDesc: "Failed to update technical data",
    grossAreaError: "Gross area cannot be less than leasable area",
    netAreaError: "Gross area must be greater than net area",
    leasableAreaRatioWarning:
      "Leasable to gross area ratio below 80%, possible underutilised space for additional revenue",
    sources: {
      database: "Database",
      documents: "Documents",
      mockData: "Mock Data",
      userInput: "User Input",
    },
    lastUpdate: "Last Update",
    nextMaintenance: "Next Maintenance",
    efficiency: "Efficiency",
    performance: "Performance",
  },
  fireSafety: {
    title: "Fire Safety",
    description: "Fire safety data for the building",
    noDataAvailable: "No fire safety data available",
    creatingRecord: "Creating fire safety record...",
    sprinklerSystem: "Sprinkler System",
    fireAlarmSystem: "Fire Alarm System",
    emergencyLighting: "Emergency Lighting",
    evacuationRoutes: "Evacuation Routes",
    fireExtinguishers: "Fire Extinguishers",
    smokeDetectors: "Smoke Detectors",
    fireDoors: "Fire Doors",
    emergencyExits: "Emergency Exits",
    assemblyPoints: "Assembly Points",
    scheduleInspection: "Schedule Inspection",
  },
};
